function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
}

export type guid = string;

export function newGuid(): guid {
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}

export function newShortGuid(): guid {
    return guid_to_base64(newGuid(), true).replace(/\//g, "_").replace(/\+/g, "-").substring(0, 22);
}

// Convert GUID string to Base-64 in Javascript
// by Mark Seecof, 2012-03-31
const hexlist = "0123456789abcdef";
const b64list = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

// GUID string with four dashes is always MSB first,
// but base-64 GUID's vary by target-system endian-ness.
// Little-endian systems are far more common.  Set le==true
// when target system is little-endian (e.g., x86 machine).
//
function guid_to_base64(g, le) {
    let s = g.replace(/[^0-9a-f]/gi, "").toLowerCase();
    if (s.length != 32) return "";
    if (le) s = s.slice(6, 8) + s.slice(4, 6) + s.slice(2, 4) + s.slice(0, 2) + s.slice(10, 12) + s.slice(8, 10) + s.slice(14, 16) + s.slice(12, 14) + s.slice(16);
    s += "0";

    let a, p, q;
    let r = "";
    let i = 0;
    while (i < 33) {
        a = (hexlist.indexOf(s.charAt(i++)) << 8) | (hexlist.indexOf(s.charAt(i++)) << 4) | hexlist.indexOf(s.charAt(i++));

        p = a >> 6;
        q = a & 63;
        r += b64list.charAt(p) + b64list.charAt(q);
    }
    r += "==";

    return r;
}

function base64_to_guid(base64, le) {
    let hex = "";
    for (let i = 0; i < 24; ) {
        const e1 = b64list.indexOf(base64[i++]);
        const e2 = b64list.indexOf(base64[i++]);
        const e3 = b64list.indexOf(base64[i++]);
        const e4 = b64list.indexOf(base64[i++]);
        const c1 = (e1 << 2) | (e2 >> 4);
        const c2 = ((e2 & 15) << 4) | (e3 >> 2);
        const c3 = ((e3 & 3) << 6) | e4;
        hex += hexlist[c1 >> 4];
        hex += hexlist[c1 & 15];
        if (e3 != 64) {
            hex += hexlist[c2 >> 4];
            hex += hexlist[c2 & 15];
        }
        if (e4 != 64) {
            hex += hexlist[c3 >> 4];
            hex += hexlist[c3 & 15];
        }
    }
    const a = hex.substr(6, 2) + hex.substr(4, 2) + hex.substr(2, 2) + hex.substr(0, 2);
    const b = hex.substr(10, 2) + hex.substr(8, 2);
    const c = hex.substr(14, 2) + hex.substr(12, 2);
    const d = hex.substr(16, 16);
    hex = a + b + c + d;
    const uuid = hex.substr(0, 8) + "-" + hex.substr(8, 4) + "-" + hex.substr(12, 4) + "-" + hex.substr(16, 4) + "-" + hex.substr(20, 12);
    return uuid;
}
